Vue.use(VueRouter)
export const constantRoutes = [
  {
    path: '/',
    component: resolve => require(["../components/home"], resolve),
    name: 'home',
  },
  {
    path: '/aboutus',
    component: resolve => require(["../components/aboutus"], resolve),
    name: 'aboutus',
  },
  {
    path: '/information',
    component: resolve => require(["../components/information"], resolve),
    name: 'information',
  },
  {
    path: '/product',
    component: resolve => require(["../components/product"], resolve),
    name: 'product',
  },
  {
    path: '/programme',
    component: resolve => require(["../components/programme"], resolve),
    name: 'programme',
  },
  {
    path: '/experience',
    component: resolve => require(["../components/experience"], resolve),
    name: 'experience',
  },
  {
    path: '/more',
    component: resolve => require(["../components/more"], resolve),
    name: 'more',
  },
  {
    path: '*',
    name:"error",
    hidden: true,
    redirect: { path: '/',menuShow: true}
  },
]
const router = new VueRouter({
  mode: 'history',//去掉#号
  routes: constantRoutes
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js